import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

// ----------------------------------------------------------------------
const hiddeableComponent = React.forwardRef(({ component, newData, ...props }, ref) => {
  const [data, setData] = useState(newData);

  const toggleShow = e => {
    setData(e);
  };

  useEffect(() => {
    if (newData != null) setData(newData);
  }, [newData, setData]);

  React.useImperativeHandle(ref, () => ({
    toggleShow,
  }));

  return <>{data ? component(data) : null}</>;
});

hiddeableComponent.propTypes = {
  newData: PropTypes.any,
  component: PropTypes.any,
};

export default hiddeableComponent;
